import React, { useEffect, useState, useRef } from 'react';
import { MoreVertical } from 'lucide-react';
export interface DropdownMenuItem {
  label: string;
  onClick: () => void;
  icon?: React.ReactNode;
  variant?: 'default' | 'danger';
}
export interface DropdownMenuProps {
  items: DropdownMenuItem[];
  className?: string;
  'data-id'?: string;
}
export function DropdownMenu({
  items,
  className = '',
  'data-id': dataId
}: DropdownMenuProps) {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (menuRef.current && !menuRef.current.contains(event.target as Node)) {
        setIsOpen(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);
  return <div className={`relative inline-block ${className}`} ref={menuRef} data-id="element-3288">
      <button onClick={() => setIsOpen(!isOpen)} className="h-12 w-12 flex items-center justify-center rounded-md border border-[#CBD5E1] hover:bg-[#F1F5F9] transition-all duration-200" aria-label="Open menu" aria-expanded={isOpen} data-id="element-3289">
        <MoreVertical className="h-5 w-5 text-[#94A3B8]" data-id="element-3290" />
      </button>

      {isOpen && <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-[0_4px_6px_rgba(15,23,42,0.1)] border border-[#CBD5E1] z-50" data-id="element-3291">
          {items.map((item, index) => <button key={index} onClick={() => {
        item.onClick();
        setIsOpen(false);
      }} style={{
        color: item.variant === 'danger' ? '#EF4444' : '#0F172A'
      }} className={`
                w-full px-4 py-3 text-left text-[14px] flex items-center gap-2
                ${item.variant === 'danger' ? 'hover:bg-[#FEF2F2]' : 'hover:bg-[#F1F5F9]'}
                ${index === 0 ? 'rounded-t-lg' : ''}
                ${index === items.length - 1 ? 'rounded-b-lg' : ''}
                transition-colors duration-200
              `} data-id="element-3292">
              {item.icon && <span className="w-5 h-5 flex items-center justify-center" data-id="element-3293">
                  {item.icon}
                </span>}
              {item.label}
            </button>)}
        </div>}
    </div>;
}